
import styles from './styles.module.css';
import { getImageFromClippingList } from "@/shared/functions/getImagesFunctions";

const MainImageTemplate = ({ related, relatedProps }) => {
    const mainImageData = related?.images?.[0];

    if (!mainImageData) return null;

    const { desktop, tablet, mobile } = relatedProps.customClippings;

    const dataMainImage = mainImageData?.value?.clippings?.filter(
        (el) => el._id === desktop
    );

    const { width, height } = dataMainImage?.[0]?.dimensions || {};

    const getFullUrl = (clippingId) => {
        const imageObject = getImageFromClippingList(
            mainImageData.value.clippings,
            clippingId
        );

        return imageObject
            ? imageObject.domain + imageObject.imgUrl
            : '';
    };

    const desktopImageUrl = getFullUrl(desktop);
    const tabletImageUrl = getFullUrl(tablet);
    const mobileImageUrl = getFullUrl(mobile);

    const title = relatedProps.title || '';
    const subtitle = relatedProps.subtitle || '';
    const epigraphe = mainImageData.epigraphe || '';

    return (
        <div className={styles['article-image-epi']}>

            <div className={styles['image-stage']}>
                <picture>
                    <source
                        media="(min-width: 770px)"
                        srcSet={desktopImageUrl}
                    />

                    <source
                        media="(min-width: 400px)"
                        srcSet={tabletImageUrl}
                    />

                    <img
                        src={mobileImageUrl}
                        alt={epigraphe || title || "Imagen principal de la nota"}
                        width={width}
                        height={height}
                        className={styles['cover-image']}
                    />
                </picture>

                <div className={styles['container-titulo']}>
                    {subtitle && (
                        <div className={styles['subtitulo']}>
                            {subtitle}
                        </div>
                    )}

                    <div className={styles['titulo']}>
                        {title}
                    </div>
                </div>
            </div>

            {epigraphe && (
                <span className={styles['epigraphe']}>
                    {epigraphe}
                </span>
            )}

        </div>
    );
};

export default MainImageTemplate;
